import {Action, Dispatch} from 'redux';
import {InsurerId} from '../../Config/dataModel';
import qrCodeAPI from '../APIs/qrCodeAPI';

const TYPES = {
    FETCH_QR_CODE_SUCCESS: 'FETCH_QR_CODE_SUCCESS'
};

const fetchQRCode = (ref: string, data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return qrCodeAPI.qrCode(ref, data).then(res => {
            dispatch(storeQRCode(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeQRCode = (data: object) => {
    return {
        type: TYPES.FETCH_QR_CODE_SUCCESS,
        qrCode: data
    };
};

export {TYPES, fetchQRCode};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/qrCodeAction.ts